"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Versioning = void 0;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _index = require("../api/index");
var Versioning = /*#__PURE__*/function () {
  function Versioning() {
    (0, _classCallCheck2["default"])(this, Versioning);
  }
  (0, _createClass2["default"])(Versioning, null, [{
    key: "create",
    value: function create(prjId) {
      var versionName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Untitled';
      return new _promise["default"](function (resolve, reject) {
        _index.ProjectsAPI.prjVersionCreate(prjId, versionName, resolve, reject);
      });
    }
  }, {
    key: "restore",
    value: function restore(prjId, versionName) {
      return new _promise["default"](function (resolve, reject) {
        _index.ProjectsAPI.prjVersionRestore(prjId, versionName, resolve, reject);
      });
    }
  }, {
    key: "delete",
    value: function _delete(prjId, versionName) {
      return new _promise["default"](function (resolve, reject) {
        _index.ProjectsAPI.prjVersionDelete(prjId, versionName, resolve, reject);
      });
    }
  }]);
  return Versioning;
}();
exports.Versioning = Versioning;
//# sourceMappingURL=Versioning.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/controllers/Versioning.js
// module id = 1260
// module chunks = 142